<script>
import request from '@/libs/request'
import { BButton, BTableLite } from 'bootstrap-vue'

export default {
  components: { BButton, BTableLite },
  data () {
    return {
      idSelectionTypes: [
        { value: 'meterNumber', title: 'Número de medidor' },
        { value: 'serialNumber', title: 'Número de serie' },
        { value: 'serieCard', title: 'Número de serie Spore' }
      ],
      formData: { selectedIdType: '', meterId: '' },
      records: [],
      meter: undefined,
      fields: [
        { key: 'serialNumber', label: 'Número de serie' },
        { key: 'cmd', label: 'Comando' },
        { key: 'energy', label: 'Consumo', formatter: (value) => this.formatMeasure(value, 'KW') },
        { key: 'energyR', label: 'Energía reactiva', formatter: (value) => this.formatMeasure(value, 'KW') },
        { key: 'currentA', label: 'Corriente A', formatter: (value) => this.formatMeasure(value, 'A') },
        { key: 'voltageA', label: 'Voltaje A', formatter: (value) => this.formatMeasure(value, 'V') },
        { key: 'potencyA', label: 'Potencia A', formatter: (value) => this.formatMeasure(value, 'W') },
        { key: 'frecuencyA', label: 'Frecuencia A', formatter: (value) => this.formatMeasure(value, 'Hz') },
        { key: 'currentC', label: 'Corriente C', formatter: (value) => this.formatMeasure(value, 'A') },
        { key: 'voltageC', label: 'Voltaje C', formatter: (value) => this.formatMeasure(value, 'V') },
        { key: 'potencyC', label: 'Potencia C', formatter: (value) => this.formatMeasure(value, 'W') },
        { key: 'frecuencyC', label: 'Frecuencia C', formatter: (value) => this.formatMeasure(value, 'Hz') },
        { key: 'createdAt', label: 'Fecha', formatter: val => val },
        { key: 'AllData', label: 'AllData', formatter: val => val },
        { key: 'actions', label: 'Acción' }
      ]
    }
  },
  computed: {
    inputTypeName () {
      const selected = this.idSelectionTypes.find(type => type.value === this.formData.selectedIdType)
      if (!selected) {
        return 'Selecciona un método de identificación de medidor'
      }
      return selected.title
    }
  },
  methods: {
    getMeterRecords () {
      const { selectedIdType, meterId } = this.formData
      return request({
        url: 'meters079/last-commands',
        method: 'GET',
        params: { [selectedIdType]: meterId }
      }).then(res => {
        this.records = res.data
      }).catch(error => {
        console.error(error)
        if (error.response.status === 404) {
          return alert('No se encontró el medidor')
        }
      })
    },
    createPayload (recordUuid) {
      return {
        message: 'aquí va el payload'
      }
    },
    formatMeasure (value, unit = '') {
      if (value === null) {
        return '-'
      }

      return `${Number(value) / 1000} ${unit}`
    },
    handleSync (payload, recordUuid) {
      const result = confirm('¿Estás seguro de que deseas resincronizar este comando?\n\n' + JSON.stringify(payload, null, 2))
      if (result) {
        return request({
          url: 'meters079/resync-data-to-sinamed',
          method: 'POST',
          params: { payload, recordUuid }
        })
      }
    }
  }
}
</script>
<template>
  <main>
    <h1>Sincronización con sinamed</h1>
    <form @submit.prevent="getMeterRecords" style="display: grid; gap:1rem; margin-top: 2rem; max-width: 40rem;">
      <div class="d-flex flex-column">
        <label for="meter-id-selector">
          Método de identificación de medidor
        </label>
        <select v-model="formData.selectedIdType" required>
          <option value="">-- Selecciona un valor --</option>
          <option v-for="option in idSelectionTypes" :key="option.value" :value="option.value">{{ option.title }}</option>
        </select>
      </div>
      <div class="d-flex flex-column">
        <label for="meter-id-input" >
          {{ inputTypeName }}
        </label>
        <input minlength="2" v-model="formData.meterId" id="meter-id-input" required />
      </div>
      <b-button type="submit" variant="primary">Buscar registros</b-button>
    </form>
    <div style="width: full; overflow-x: scroll;">
        <b-table-lite class="mt-2" :items="records" :fields="fields">
          <template #cell(actions)="data">
            <b-button @click="handleSync(data.item.payload, data.item.uuid)">Sincronizar</b-button>
          </template>
        </b-table-lite>
    </div>
    {{ meter }}
  </main>
</template>
